<div class="search-cases-container">
  <div class="panel-header">
    <h3>Search Cases</h3>
  </div>

  <div class="form-grid">
    <!-- Row 1: Inputs -->
    <div class="form-field case-no">
      <div class="field-label-row">
        <label>Case #</label>
        <app-warning-tooltip [message]="numericTooltip(12)"
          [showInfoIcon]="true" appearance="suggestion" [showTooltip]="numericHint() === 'caseNo'" />
      </div>
      <div class="numeric-input-row numeric-input-row--case">
        <div class="input-with-icon">
          <input #caseNoInput type="text" appNumericOnly [appNumericOnlyMaxLength]="12" maxlength="12" placeholder="Case Number" [ngModel]="criteria().caseNo"
            (invalidInputAttempt)="showNumericHint('caseNo')" (ngModelChange)="updateField('caseNo', $event)" (keydown.enter)="search()" aria-label="Case number" />
          @if (criteria().caseNo) {
          <button class="icon-btn" [attr.title]="tooltipTexts.copyCaseNumber" (click)="copyCaseNo()" [attr.aria-label]="isCopied() ? 'Copied to clipboard' : 'Copy case number to clipboard'">
            @if (isCopied()) {
            <!-- Checkmark Icon -->
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            } @else {
            <!-- Copy Icon -->
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
            </svg>
            }
          </button>
          }
        </div>
      </div>
    </div>

    <div class="form-field street-no">
      <div class="field-label-row">
        <label>Street Number</label>
        <app-warning-tooltip [message]="numericTooltip(10)"
          [showInfoIcon]="true" appearance="suggestion" [showTooltip]="numericHint() === 'streetNo'" />
      </div>
      <div class="numeric-input-row">
        <input type="text" appNumericOnly [appNumericOnlyMaxLength]="10" maxlength="10" placeholder="Street Number" [ngModel]="criteria().streetNo"
          (invalidInputAttempt)="showNumericHint('streetNo')" (ngModelChange)="updateField('streetNo', $event)" (keydown.enter)="search()" aria-label="Street number" />
      </div>
    </div>

    <div class="form-field direction">
      <label>Direction</label>
      <app-searchable-select [items]="lookUpService.directionSearch.data()" bindLabel="directionDesc"
        bindValue="directionCode" placeholder="Select Direction" [model]="criteria().direction"
        (modelChange)="updateField('direction', $event)" (search)="onDirectionSearchChange($event)">
      </app-searchable-select>
    </div>

    <div class="form-field street-name">
      <label>Street Name</label>
      <input type="text" placeholder="Street Name" [ngModel]="criteria().streetName"
        (ngModelChange)="updateField('streetName', $event)" (keydown.enter)="search()" aria-label="Street name" />
    </div>

    <div class="form-field type">
      <label>Type</label>
      <app-searchable-select [items]="lookUpService.streetTypeSearch.data()" bindLabel="streetTypeDesc"
        bindValue="streetType" placeholder="Select Type" [model]="criteria().type"
        [loadingMore]="lookUpService.streetTypeSearch.loadingMore()"
        (modelChange)="updateField('type', $event)" (search)="onStreetSearchChange($event)" (scrollToEnd)="onStreetScrollToEnd()">
      </app-searchable-select>
    </div>

    <div class="form-field unit">
      <label>Unit #</label>
      <input type="text" placeholder="Unit" [ngModel]="criteria().unitNo"
        (ngModelChange)="updateField('unitNo', $event)" (keydown.enter)="search()" aria-label="Unit number" />
    </div>

    <div class="form-field apn">
      <div class="field-label-row">
        <label>APN</label>
        <app-warning-tooltip [message]="numericTooltip(15)"
          [showInfoIcon]="true" appearance="suggestion" [showTooltip]="numericHint() === 'apn'" />
      </div>
      <div class="numeric-input-row">
        <input type="text" appNumericOnly [appNumericOnlyMaxLength]="15" placeholder="APN" [ngModel]="criteria().apn" (ngModelChange)="updateField('apn', $event)"
          (invalidInputAttempt)="showNumericHint('apn')" (keydown.enter)="search()" aria-label="APN" />
      </div>
    </div>
  </div>
  <!-- Action Buttons -->
  <div class="actions-row">
    <button class="btn-new btn-search" [disabled]="hasNoSearchValues()" (click)="search()" aria-label="Search cases">
      <span class="btn-icon">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </span>
      Search
    </button>
    <button class="btn btn-secondary" (click)="reset()" aria-label="Reset search form">
      <span class="btn-icon">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67"></path>
        </svg>
      </span>
      Reset
    </button>
  </div>
</div>